
export default {
    name: 'VerticalEllipses',
};
